import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type ConvertStepToReadOnlyModalProps = {
  isOpen: boolean;
  close: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const ConvertStepToReadOnlyModal = ({
  isOpen,
  close,
  onConfirm,
  isLoading = false,
}: ConvertStepToReadOnlyModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <StatusModal type="warning" title="Change step to read-only?">
        All fields in this step will become read-only, and any field-specific
        configurations (such as single-select options) will be removed.
        <br />
        <br />
        Are you sure you want to continue?
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button type="button" disabled={isLoading}>
            Go back
          </Button>
        </Modal.RawClose>
        <Button
          type="button"
          customType="primary"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        >
          Convert step
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
